import client from '../client';

export const _createCloudTalkAgent = async (payload) => {
  return await client.post(`communications/agents`, payload, { credentials: 'omit' });
};

export const _startCloudTalkCall = async (payload) => {
  return await client.post(`communications/calls/start`, payload, { credentials: 'omit' });
};
